import PropTypes from 'prop-types';

export const announcementShape = PropTypes.shape({
  // Entra na chave do "já viu": trocar o texto sem trocar o id não mostra de novo para quem já
  // fechou. Para reapresentar um aviso reformulado, suba a versão (`pix-4x:v1` → `pix-4x:v2`).
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  badge: PropTypes.string,
  // Print da novidade, logo abaixo do texto. Arte em 16:9: o espaço é reservado nessa proporção
  // antes de a imagem carregar, para o modal não pular ao trocar de aviso.
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  content: PropTypes.node,
  learnMore: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  }),
  // Rota do painel (ou URL) para o produtor experimentar a novidade. Ao contrário do learnMore, o
  // Ver agora fecha o modal, e fechar marca como vistos todos os avisos exibidos, não só este.
  // Com seeNow, o learnMore não aparece: o link do aviso é o Ver agora.
  seeNow: PropTypes.string,
  // 'AAAA-MM-DD' vale até o fim desse dia; data com hora corta no instante.
  expiresAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
});
